// extracted by mini-css-extract-plugin
module.exports = {"languageSwitcher":"styles_languageSwitcher_1WGNBO_QUOcev3by4_9JEM","selectLabel":"styles_selectLabel_PUyK9lFuLtECjBUcz9hwV","icon":"styles_icon_1gk1jIjqqAV5of3hhcv5FL"};